<div
    class="d-flex justify-content-between pt-3 px-1 align-items-center overflow-x-auto overflow-x-md-hidden gap-2 gap-lg-none"
    style="gap: 6x;cursor: pointer;"
  >
   
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('topPick')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="top-picks.jfif"
      />
      <span
        class="text-center lh-1 p-1 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
      >
        Top  picks</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Apples')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="apples.png"
      />
      <span class="p-2 p-md-1" style="font-size: 12px; color: rgb(122, 121, 121)"
        >Apple</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Berries')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="berries.png"
      />
      <span
        class="text-center p-2 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
        >Berries</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Citrus fruits')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="citrus fruits.png"
      />
      <span
        class="text-center lh-1 p-1 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
      >
        Citrus fruits</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Kiwi')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="kiwi .png"
      />
      <span
        class="text-center p-2 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
        >Kiwi</span
      >
    </div>

    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Avocado')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="avacados.png"
      />
      <span
        class="text-center p-2 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
        >Avocado</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Pear')"
    >
      <img
        class="border rounded-circle category-img"
    
        src="pears.png"
      />
      <span
        class="text-center p-2 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
        >Pear</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Grapes')"
    >
      <img
        class="border rounded-circle category-img"
       
        src="grapes.png"
      />
      <span
        class="text-center p-2 p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
        >Grapes</span
      >
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center category"
      (click)="updateArticleByCategory('Tropical fruits')"
    >
      <img
        class="border rounded-circle category-img"
        
        src="tropical fruits.png"
      />
      <span
        class="text-center lh-1 p-1  p-md-1"
        style="font-size: 12px; color: rgb(122, 121, 121)"
        >Tropical fruits</span
      >
    </div>
    <div
    class="d-flex flex-column align-items-center justify-content-center category"
    (click)="updateArticleByCategory('Stone Fruits')"
  >
    <img
      class="border rounded-circle category-img"
     
      src="stone-fruits.png"
    />
    <span
      class="text-center lh-1  p-1 p-md-1"
      style="font-size: 12px; color: rgb(122, 121, 121)"
      >Stone fruits</span
    >
  </div>
  </div>